import { loc } from '@/localization';
import { optionsService } from '@/services/instance/optionsService';

export enum SamlErrorType {
    SubuserLimitExceeded = 'SubuserLimitExceeded',
    InviterLicenseExpired = 'InviterLicenseExpired',
    InviteeHasOwnLicense = 'InviteeHasOwnLicense',
    IdpNotFound = 'IdpNotFound',
    ResponseMissing = 'ResponseMissing',
    Other = 'Other',
}

type ErrorMessage = {
    text: string;
    contactsSubject?: string;
};

const typeToMessageMap: Record<SamlErrorType, ErrorMessage> = {
    [SamlErrorType.SubuserLimitExceeded]: {
        text: loc.Login.SamlErrorDescriptionSubuserLimitExceeded,
        contactsSubject: 'Couldn’t log in via SSO - Not enough user slots',
    },
    [SamlErrorType.InviterLicenseExpired]: {
        text: loc.Login.SamlErrorDescriptionInviterLicenseExpired,
        contactsSubject: 'Couldn’t log in via SSO - FlippingBook Online license has expired',
    },
    [SamlErrorType.InviteeHasOwnLicense]: {
        text: loc.Login.SamlErrorDescriptionInviteeHasOwnLicense,
        contactsSubject: 'Couldn’t log in via SSO - I have a separate license for FlippingBook Online',
    },
    [SamlErrorType.IdpNotFound]: {
        text: loc.Login.SamlErrorDescriptionObjectNotFound,
        contactsSubject: 'Couldn’t log in via SSO - No existing SSO connection found',
    },
    [SamlErrorType.ResponseMissing]: {
        text: loc.Login.SamlErrorDescription,
        contactsSubject: 'Couldn’t log in via SSO',
    },
    [SamlErrorType.Other]: {
        text: loc.Login.SamlErrorDescription,
        contactsSubject: 'Couldn’t log in via SSO',
    },
};

export function getSamlErrorType(): SamlErrorType {
    const errors = optionsService.getError()?.Errors;
    if (errors?.some((x) => x.ErrorCode === 'Constraint3rdParty')) {
        if (errors.some((e) => e.ErrorCode === 'SubuserLimitExceeded')) {
            return SamlErrorType.SubuserLimitExceeded;
        }

        if (errors.some((e) => e.ErrorCode === 'LicenseExpired')) {
            return SamlErrorType.InviterLicenseExpired;
        }
        if (errors.some((e) => e.ErrorCode === 'InviteeHasOwnLicense')) {
            return SamlErrorType.InviteeHasOwnLicense;
        }
    }
    if (errors?.some((x) => x.ErrorCode === 'SAMLResponseMissing')) {
        return SamlErrorType.ResponseMissing;
    }
    if (errors?.some((x) => x.ErrorCode === 'ObjectNotFound')) {
        return SamlErrorType.IdpNotFound;
    }

    return SamlErrorType.Other;
}

export function getSamlErrorMessage(type: SamlErrorType): ErrorMessage {
    return typeToMessageMap[type];
}
